export const environment = {
  production: true,
  api: {
    host: 'https://apilocal.bci.cl/bci-produccion/api-bci',
    version: 'v1.0',
  },
  reCaptchaSiteKey: '6Ld86MUUAAAAABys_wPL-N-vjt-ADus5D4CD4dYO',
  ibm_client_id: '1e4839e8-3935-4f48-a83e-18c604dedac7',
  gtmId: 'GTM-MZSJ96J'
}
